export const services = [
  {
    id: "lazer",
    title: "Lazer Epilasyon",
    icon: "ri-flashlight-line",
    description:
      "Yüz, kol, bacak, koltuk altı ve tüm vücut bölgeleri için cihaz destekli lazer epilasyon uygulamaları. Seans planlaması ihtiyaca göre belirlenir.",
    message: "Merhaba, Lazer Epilasyon hizmeti hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "cilt",
    title: "Cilt Bakımı",
    icon: "ri-leaf-line",
    description:
      "Medikal cilt bakımı, enzim peeling, carboxy, cam cilt bakımı, anti-aging ve leke-akne odaklı bakım seçenekleri.",
    message: "Merhaba, Cilt Bakımı hizmeti hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "kas-kirpik",
    title: "Kaş & Kirpik",
    icon: "ri-eye-line",
    description:
      "Kirpik ve kaş laminasyonu, klasik ipek kirpik ve altın oran kaş alımı ile yüz hatlarınıza uygun bir görünüm.",
    message: "Merhaba, Kaş & Kirpik hizmetleri hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "kalici-makyaj",
    title: "Kalıcı Makyaj",
    icon: "ri-brush-line",
    description:
      "Microblading, kalıcı dipliner ve dudak renklendirme uygulamaları ile zamandan tasarruf eden pratik bir görünüm.",
    message: "Merhaba, Kalıcı Makyaj hizmetleri hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "agda-masaj",
    title: "Ağda ve Masaj",
    icon: "ri-hand-heart-line",
    description:
      "Tüm vücut ağda uygulamaları ile meridyen ve kupa masajı seçenekleri; rahatlatıcı bir bakım deneyimi.",
    message: "Merhaba, Ağda ve Masaj hizmetleri hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "bolgesel",
    title: "Bölgesel Uygulamalar",
    icon: "ri-body-scan-line",
    description:
      "Bölgesel incelme ve vücut şekillendirme odaklı seans programları; uygulama kapsamı kişiye göre planlanır.",
    message: "Merhaba, Bölgesel Uygulamalar hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "sac-simulasyon",
    title: "Saç Simülasyonu",
    icon: "ri-user-voice-line",
    description:
      "Saç simülasyonu uygulamaları; kapsam ve fiyat, uygulama yapılacak bölgeye göre değerlendirilir.",
    message: "Merhaba, Saç Simülasyonu uygulaması hakkında detaylı bilgi almak istiyorum.",
  },
  {
    id: "kamuflaj",
    title: "Kamuflaj Uygulamaları",
    icon: "ri-contrast-drop-2-line",
    description:
      "Dikiş izi, vitiligo ve çatlak kamuflajı uygulamaları; ön değerlendirme sonrası bölgeye göre planlanır.",
    message: "Merhaba, Kamuflaj Uygulamaları hakkında detaylı bilgi almak istiyorum.",
  },
];